import React, { useState, useEffect } from "react"

// Libs
import slugify from 'slugify'

// Gatsby
import { useStaticQuery, graphql, navigate } from "gatsby"
import Img from "gatsby-image"

// Icons
import { IoIosArrowRoundForward } from "react-icons/io"

// Components
import Slider from './slider/slider'

// Helpers
import { truncate } from '../helpers'


const RecentNews = () => {
  const [loaded, setStatus] = useState(false)
  const [news, setNews] = useState()

  const data = useStaticQuery(graphql`
    query GetAllArticles {
      allStrapiArticle {
        nodes {
          intro
          title
          date(fromNow: true)
          image {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)

  useEffect(() => {
    if (data && data.allStrapiArticle) {
      let news = data.allStrapiArticle.nodes.map(n => ({ ...n }))
      setNews(news.map((n, i) => (
        <div key={i} onClick={() => navigate(`/blog/${slugify(n.title)}`)} className="blog-card bg-white hover:shadow-lg cursor-pointer relative transition duration-800" style={{ minHeight: "550px" }}>
          <Img fluid={n.image.childImageSharp.fluid} />
          <div className="mx-4" >
            <h4 className="text-xl font-bold leading-snug tracking-wide mb-5 text-gray-900">
              {n.title}
            </h4>
            <h5 className="text-base font-light text-gray-700 leading-snug tracking-wide">
              {truncate(n.intro, 100, true)}
            </h5>
            <div className="flex mt-6 items-center justify-between">
              <div>
                <p className="text-sm text-main_color font-thin">
                  {n.date}
                </p>
              </div>
              <div className="flex items-center" style={{ bottom: 0, right: 20 }} onClick={() => navigate(`blog/${slugify(n.title)}`)}>
                <p>Leer más</p>
                <IoIosArrowRoundForward className="mt-1 text-xl" />
              </div>
            </div>
          </div>
        </div>
      )))

      setStatus(true)
    }
  }, [data])

  return (
    <section className="grid grid-cols-12 bg-gray-200">
      <h4 className="col-span-12 mx-auto mt-20 mb-10 text-2xl tracking-wider">BLOG</h4>
      <div className="col-start-2 col-span-10 block">
        {news && loaded && (
          <>
            <div className="hidden lg:block">
              <Slider items={news} settings={{ slidesToShow: 3, dots: false }} />
            </div>
            <div className="block lg:hidden">
              <Slider items={news} settings={{ slidesToShow: 1, dots: false }} />
            </div>
          </>
        )}
      </div>
      <div className="mt-6 mb-20 mx-auto col-span-12 relative mt-10">
        <span className="animate-ping absolute h-2 w-2 rounded-full bg-pink-400" style={{ top: "-2px", right: "-2px" }}></span>
        <button onClick={() => navigate('/blog')} className="p-4 font-light bg-main_color hover:bg-secondary_color">Ver todos los artículos</button>
      </div>
    </section>
  )
}

export default RecentNews
